export const ERROR_TOOLTIP_TEXT = 'Ad name is required.';
export const DISABLED_NEXT_TOOLTIP_TEXT =
  'Name is required for each duplicated ad. Check each ad tab and fix the highlighted fields before proceeding.';
